import Repository from "./repo";

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export default class WorkFlowController {
  constructor() {
    this.repo = new Repository();
  }

  findByFilter(modelName, filter, options) {
    if (!filter.limit) filter.limit = 1000;
    return this.repo.findByFilter(modelName, filter, options);
  }

  findWhere(modelName, query, options) {
    return this.repo.findWhere(modelName, this._formatQuery(query), options);
  }

  findOne(modelName, query, options) {
    return this.repo.findOne(modelName, this._formatQuery(query), options);
  }

  create(modelName, data, options) {
    return this.repo.create(
      modelName,
      data,
      options
    );
  }

  async execute(modelName, aggregateId, action, data, options) {
    const res = await this.repo.execute(
      modelName,
      aggregateId,
      action,
      data,
      options
    );
    await delay(100);
    return res;
  }

  _formatQuery(query) {
    if (query && query.where) return { where: query.where, limit: 1000 };
    return { where: query, limit: 1000 };
  }

  printInvoice(query, options) {
    return this.repo.getPdf('invoice', 'print', query, options);
  }
  printPerSuiteEnergyReport(query, options) {
    return this.repo.getPdf('report', 'print/perSuiteEnergyReport', query, options);
  }
  printCopCalculationReport(query, options) {
    return this.repo.getPdf('report', 'print/copCalculationReport', query, options);
  }
}



// WEBPACK FOOTER //
// ./src/services/workflowController.js